import React from "react";
import {Routes, Route, Navigate} from "react-router-dom";
import PrivateCheck from "layouts/auth/PrivateCheck"
import RtlLayout from "layouts/rtl";
import AdminLayout from "layouts/admin";
import AuthLayout from "layouts/auth";
import NewsForm from "views/admin/news/components/NewsForm";

const App = () => {

    return (
        <Routes>
            {/*<Routes  history={history}>*/}
            <Route path="auth/*" element={<AuthLayout/>}/>
            <Route path="admin/*" element={<PrivateCheck><AdminLayout/></PrivateCheck>}/>
            <Route path="rtl/*" element={<PrivateCheck><RtlLayout/></PrivateCheck>}/>
            <Route path="/" element={<PrivateCheck><Navigate to="/rtl" replace/></PrivateCheck>}/>
        </Routes>
    );
};


export default App;
